import { render, staticRenderFns } from "./ourAppCn.vue?vue&type=template&id=13e8dea3&scoped=true&"
import script from "./ourAppCn.vue?vue&type=script&lang=js&"
export * from "./ourAppCn.vue?vue&type=script&lang=js&"
import style0 from "./ourAppCn.vue?vue&type=style&index=0&id=13e8dea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8dea3",
  null
  
)

export default component.exports